import * as React from "react";
import "./drivingGreenLogo.scss";

const logo = "/assets/img/dg-logo-current.svg";

interface Props {
	className?: string;
}

/** Current Driving Green wordmark from the partner portal design. */
export default function DrivingGreenLogo(props: Props) {
	const className = `c-driving-green-logo${props.className ? ` ${props.className}` : ""}`;

	return (
		<img src={logo} className={className} alt="Driving Green"/>
	);
}
